import React from "react";

export default function GunaScoreDial({ score, max = 36 }) {
  const pct = Math.max(0, Math.min(1, score / max));
  const radius = 54;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - pct);
  const verdict =
    pct >= 0.75 ? "Excellent match" : pct >= 0.5 ? "Good match" : pct >= 0.32 ? "Average match" : "Needs review";

  return (
    <div style={styles.wrap}>
      <svg width="140" height="140" viewBox="0 0 140 140" style={{ animation: "km-pop 0.4s var(--ease)" }}>
        <circle cx="70" cy="70" r={radius} fill="none" stroke="var(--paper-2)" strokeWidth="12" />
        <circle
          cx="70" cy="70" r={radius} fill="none"
          stroke="url(#gunaGradient)" strokeWidth="12" strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={offset}
          transform="rotate(-90 70 70)"
          style={{ transition: "stroke-dashoffset 0.8s var(--ease)" }}
        />
        <defs>
          <linearGradient id="gunaGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--gold)" />
            <stop offset="100%" stopColor="var(--terracotta)" />
          </linearGradient>
        </defs>
        <text x="70" y="66" textAnchor="middle" fontFamily="var(--font-display)" fontSize="30" fontWeight="700" fill="var(--ink)">
          {score}
        </text>
        <text x="70" y="86" textAnchor="middle" fontFamily="var(--font-body)" fontSize="12" fill="var(--ink-soft)">
          out of {max}
        </text>
      </svg>
      <div style={styles.verdict}>{verdict}</div>
    </div>
  );
}

const styles = {
  wrap: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8 },
  verdict: {
    fontFamily: "var(--font-body)", fontSize: 13.5, fontWeight: 700,
    color: "var(--terracotta-dark)", letterSpacing: 0.3,
  },
};
